module.exports = __webpack_public_path__ + "img/mainmenbutton.b3cf56ad.png";